import { Provider } from './provider';

export class ProviderFlixmedia extends Provider {
    public getAvailabilitySource(): string {
        return `https:/*                                                                     */
    }

    public isContentAvailable(parsedAvailabilityResponse: Record<string, string>): boolean {
        return parsedAvailabilityResponse.event === 'matchhit';
    }

    public createIframeSrc(): string {
        return `https:/*                                                                       */
    }
}
